
var Stmt = require('./stmt');
var ListHolder = require('./list-holder');

/**
 * The equivalent of a SQL multi statement.
 */
module.exports = new Class({
	Extends: Stmt
	,Implements: ListHolder
	,Tag: 'sql-multi-stmt'
	,Properties: {
		/**
		 * The statements list.
		 */
		stmts: {
			type: Array
			,set(x) {
				this.list = x;
			}
			,get() {
				return this.list;
			}
		}
	}

	,render(params) {
		return this.renderListWs(this.list, params, ";\n");
	}
});
